var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"owl-usage-donut-chart tw-p-1 tw-text-gray"},[(!_vm.isLoading)?_c('donut-chart',{ref:"highchartsDonut",attrs:{"id":_vm.chartId,"options":_vm.chartOptions}}):_c('owl-loading-indicator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }